import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  paypay: {
    id: 'product_jp_points_paypay',
    defaultMessage: 'Earn up to {points, html} PayPay points',
  },
  rakuten: {
    id: 'product_jp_points_rakuten',
    defaultMessage: 'Earn up to {points, html} Rakuten points via campaign',
  },
  points: {
    id: 'product_jp_points',
    defaultMessage: '{points}pt',
  },
} as Record<string, I18nDefinition>
